import { Component, OnInit, Input,Output,EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { AccountClientDetailsService } from '../../../../service/account-client-edit/account-client-details.service';
import { DocumentType } from '../../../../../models/document-type';
import { FlashMessagesService } from 'angular2-flash-messages';
import { ConfirmComponent } from "../../../../../shared/confirm/confirm.component";
import { saveAs } from 'file-saver';
import { DialogService } from "ng2-bootstrap-modal";
import * as moment from 'moment';
import 'moment/locale/pt-br';
import { IMyDpOptions } from 'mydatepicker';

@Component({
	selector: 'app-attachment-grid',
	templateUrl: './attachment-grid.component.html',
	styleUrls: ['./attachment-grid.component.scss']
})
export class AttachmentGridComponent implements OnInit {

	@Input('attachmentList') attachmentList: any[] = [];
	@Input('accountClientID') accountClientID: string = "";

	@Output() selectedIdsChange = new EventEmitter<any>();
	selectedIds: string[] = [];
	
	public documentTypes: DocumentType;
	private permissoes = [];
	private today = moment();

	direction: number;

	isDesc: boolean = false;
 	column: string = 'Origem';
    
	// adicionei para o checkbox
	private allAttachs: any[] = [];
	toggleAllCheckbox: boolean = false;

	//Option to datepicker
	private myDatePickerOptions: IMyDpOptions = {
		// other options...
		dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
		monthLabels: { 1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez' },
		dateFormat: 'dd/mm/yyyy',
		showTodayBtn: false,
		//disableSince: {year: this.today.year(), month: this.today.month()+1, day: this.today.date()},
		disableUntil: { year: this.today.year(), month: this.today.month() + 1, day: this.today.date() },
		//disableDateRanges: [{begin: {year: 2016, month: 11, day: 14}, end: {year: 2016, month: 11, day: 20}}],
		//editableDateField: false,
		//height: "30px"
	};

	constructor(private accountClientDetailsService: AccountClientDetailsService, private dialogService: DialogService, private router: Router, private route: ActivatedRoute, private flashMessagesService: FlashMessagesService) {
		this.documentTypes = new DocumentType();
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		this.sort(this.column);
	}

	sort(property){
		this.isDesc = !this.isDesc; //change the direction    
		this.column = property;
		let direction = this.isDesc ? 1 : -1;
	
		this.attachmentList.sort(function(a, b){

			if (a[property] < b[property]) {
				return -1 * direction;
			}
			else if (a[property] > b[property]) {
				return 1 * direction;
			}
			else{
				return 0;
			}
		});
	}

	setAttachStatus(e, i) {
		this.attachmentList[i].Status = Number(e.target.value);
	}

	setDataOriginal(value, i) {
		this.attachmentList[i].DataValidadeOriginal = value ? value.date.year + "-" + value.date.month + "-" + value.date.day : null;
	}

	

	updateAttachClient() {
		for (var key in this.attachmentList) {
			const tempDatePickerObj = this.attachmentList[key].DataValidade;
			this.attachmentList[key].DataValidade = tempDatePickerObj ? tempDatePickerObj.date.year + "-" + tempDatePickerObj.date.month + "-" + tempDatePickerObj.date.day : null;
		}

		this.accountClientDetailsService.updateAttachClient(this.attachmentList).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show("Alterações de anexo feitas com sucesso", { cssClass: 'alert-success', timeout: 6000 });
				this.attachmentReload();
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
			return false;
		});
	}

	attachmentReload() {
		let order = {
			property: this.column,
			direction: this.isDesc ? 1 : -1
		};

		this.accountClientDetailsService.attachmentReload.next(order);
	}

	inactivateAttachment(id) {
		this.accountClientDetailsService.inactivateAttachment(id).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show("Anexo removido com sucesso!", { cssClass: 'alert-success', timeout: 6000 });
				this.attachmentReload();
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

	showRemoveAttachModal(id) {
		let disposable = this.dialogService.addDialog(ConfirmComponent, {
			title: 'Confirmação',
			message: 'Confirma a exclusão do anexo?',
			warning: "Essa ação não poderá ser revertida."
		},
			{
				backdropColor: 'rgba(0, 0, 0, 0.5)'
			}).subscribe((isConfirmed) => {
				//We get dialog result
				if (isConfirmed) {
					this.inactivateAttachment(id);
				}
				else {
					//Do nothing here for now
				}
			});
	}

	downloadAttachment(index) {
		this.accountClientDetailsService.downloadAttachment(this.attachmentList[index].ID).subscribe(blob => {
			if (blob) {
				saveAs(blob, this.attachmentList[index].NomeArquivo);
			} else {
				this.flashMessagesService.show("Problema ao baixar o arquivo", { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

	checkBoxSelected(attachmentID: string, checked: boolean) {
     
	  	var objIds = {};
		
		if (checked) {
		  this.selectedIds.push(attachmentID);
		  objIds = {selectedIds: this.selectedIds, idsToRemove:[]};
		} else {
		  this.selectedIds = this.selectedIds.filter(x => x !== attachmentID);
		  objIds = {selectedIds: this.selectedIds, idsToRemove:attachmentID};
		}
		// avisa o componente pai
		this.selectedIdsChange.emit(objIds);
	  }
	   

	toggleAllChecks(event: Event): void {
		const checked = (event.target as HTMLInputElement).checked;
		var objIds = {};

		if (checked) {
			this.selectedIds = this.attachmentList.map(a => a.ID);
			this.toggleAllCheckbox = true;
			objIds = {selectedIds: this.selectedIds, idsToRemove:[]}
		} else {
			this.selectedIds = [];
			this.toggleAllCheckbox = false;
			objIds = {selectedIds: this.selectedIds, idsToRemove:this.attachmentList.map(a => a.ID)}
		}

		this.selectedIdsChange.emit(objIds);
	}




	// canEditAttachment(){
	// 	if (this.profileUser === 'Estagiário de Crédito' ||
	// 	profileUser === 'Assistente de Crédito' ||
	// 	profileUser === 'Analista de Crédito' ||
	// 	profileUser === 'Coordenador de Crédito' ||
	// 	profileUser === 'Gerente de Crédito'){

	// 	}
	// }


}



// WEBPACK FOOTER //
// ./src/app/account-client/component/account-client-details/attachment-account-client/attachment-grid/attachment-grid.component.ts